import React, { FC, useState } from 'react';

import { Box, Stack } from '@chakra-ui/react';

import { SearchBox } from 'components/DataEntry/Input/SearchBox';

import { AllIcons } from './AllIcons';

interface IMeta {}

export const ResourceIcons: FC<IMeta> = props => {
  const [term, setTerm] = useState('');

  return (
    <Stack spacing={6} overflowX="hidden">
      <Box w={'xl'}>
        <SearchBox
          value={term}
          onChange={setTerm}
          placeholder="Search icons"
          onClickClose={() => setTerm('')}
        />
      </Box>
      <Box>
        <AllIcons filterTerm={term} />
      </Box>
    </Stack>
  );
};
